import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['name']
  static values = { url: String, tool: String, projectId: String }

  async create (event) {
    const button = event.currentTarget
    const original = button.innerHTML
    button.disabled = true
    button.textContent = 'Creating…'

    const name = this.hasNameTarget ? this.nameTarget.value.trim() : ''
    const csrfToken = document.querySelector('meta[name=csrf-token]')?.content
    const response = await fetch(this.urlValue, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-Token': csrfToken },
      body: JSON.stringify({ project_id: this.projectIdValue, tool: this.toolValue, name })
    })

    if (!response.ok) {
      button.disabled = false
      button.innerHTML = original
      alert("Couldn't add it — you may need admin access on this Basecamp project. You can also add it in Basecamp directly.")
      return
    }

    const frame = this.element.closest('turbo-frame')
    const src = frame?.getAttribute('src')
    if (src) {
      frame.removeAttribute('src')
      requestAnimationFrame(() => frame.setAttribute('src', src))
    } else if (frame && typeof frame.reload === 'function') {
      frame.reload()
    }
  }
}
